import { observer } from 'mobx-react-lite';
import Page from './page';
import './style.css';
import m from 'skin/store/mb';

const Right = ({ action, current, list }) => {
	const mb = m.isMobile;
	let cls = ['skin-ms-ttl-right', 'ms-ttl-right'];
	cls = cls.join(' ');
	const max = list.length - 1;
	const st = { backgroundImage: 'url(skin/img/close.svg)' };
	return (
		<div className={cls}>
			<div>
				{list.map((el, i) => (
					<Page
						key={i}
						data={el}
						item={i}
						current={current}
						max={max}
						action={action}
						mb={mb}
					/>
				))}
			</div>
			{!mb && <span className="ico-r" style={st} onClick={close}></span>}
		</div>
	);
	function close() {
		const o = {
			type: 'master',
			action: 'exit',
		};
		action(o);
	}
};

export default observer(Right);
